/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_No_Active_WebsiteInputs */

const en_common_no_active_website = /** @type {(inputs: Common_No_Active_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active website detected`)
};

const es_common_no_active_website = /** @type {(inputs: Common_No_Active_WebsiteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se detectó un sitio activo`)
};

/**
* | output |
* | --- |
* | "No active website detected" |
*
* @param {Common_No_Active_WebsiteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_no_active_website = /** @type {((inputs?: Common_No_Active_WebsiteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_No_Active_WebsiteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_no_active_website(inputs)
	return en_common_no_active_website(inputs)
});